import { render, staticRenderFns } from "./our-community-guidelines.vue?vue&type=template&id=5768c7ec&scoped=true"
import script from "./our-community-guidelines.vue?vue&type=script&lang=js"
export * from "./our-community-guidelines.vue?vue&type=script&lang=js"
import style0 from "./our-community-guidelines.vue?vue&type=style&index=0&id=5768c7ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5768c7ec",
  null
  
)

export default component.exports